var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('MobileCol',_vm._l((_vm.items),function(item,index){return _c('v-alert',{key:index,attrs:{"color":"primary","block":"","dark":"","dense":""}},[_vm._v(" "+_vm._s(item.heading)+": "+_vm._s(item.text)+" ")])}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }